export default {
    today: 'Today',
    oneDayAgo: '1 day ago',
    daysAgo: '{{count}} days ago',
    oneWeekAgo: '1 week ago',
    weeksAgo: '{{count}} weeks ago',
    oneMonthAgo: '1 month ago',
    monthsAgo: '{{count}} months ago',
    anonymous: 'Anonymous',
    userAnswer: 'User Answer:',
    average: 'Average',
    employeesOutOf: '{{answeredCount}} employees out of {{totalCount}} answered this question.',
    reply: 'Reply',
    replyPlaceholder: 'Write a reply...',
    viewMore: 'View {{count}} More',
    errors: {
        fetchResultsFailed: 'Failed to fetch evaluation results. Please try again later.',
        fetchCommentsFailed: 'Failed to fetch question comments. Please try again later.',
    },
};
